import { profileRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const profileRouteMetadata: IRouteMetadataObj<typeof profileRoutesObj> = {
  home: {
    title: "profile.title",
    description: "profile.description",
    lazy: () => import("@pages/studentPages/profile/page"),
    mode: "index",
    type: "main",
    icon: "LayoutGridLine",
    breadcrumbs: [],
    permission,
  },
};

export const profileRoutes = createRoute<typeof profileRoutesObj>(
  profileRoutesObj,
  profileRouteMetadata,
);
